import { styled } from '@volkswagen-onehub/components-core';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

const SkeletonContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({theme}) => theme.size.dynamic0050 };
`;

export const PaginationSkeleton = () => {

  return (
    <SkeletonContainer>
      <Skeleton width="32" height="32" borderRadius="0" circle />
      <Skeleton width="10" height="20" borderRadius="0" />
      <Skeleton width="10" height="20" borderRadius="0" />
      <Skeleton width="10" height="20" borderRadius="0" />
      <Skeleton width="20" height="10" borderRadius="0" />
      <Skeleton width="10" height="20" borderRadius="0" />
      <Skeleton width="32" height="32" borderRadius="0" circle />
    </SkeletonContainer>
  );
};
